module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-kanagawa-1-d6e31d61904204c5d3d3417ff2f71a03.png";